import { api } from '../index';

const prefix = '/api/basic_info/user/';

export function apiIndex() {
	return api.get(prefix + 'index');
}

export function apiSelectUserList(param) {
	return api.post(prefix + 'selectUserList', param);
}

export function apiSelectUser(param) {
	return api.post(prefix + 'selectUser', param);
}

export function apiChangePassword(param) {
	return api.post(prefix + 'changePassword', param);
}

export function apiInsertUser(param) {
	param.mode = 'insert';
	return apiSubmitUser(param);
}

export function apiUpdateUser(param) {
	param.mode = 'update';
	return apiSubmitUser(param);
}

export function apiDeleteUser(param) {
	param.mode = 'delete';
	return apiSubmitUser(param);
}

function apiSubmitUser(param) {
	return api.post(prefix + 'submitUser', param);
}

export function apiEncryptPasswords() {
	return api.get(prefix + 'encryptPasswords');
}

export function apiSimpleUserList(param) {
	return api.get(prefix + 'simpleUserList', { params: param });
}
